import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule, Location } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { L94Rfil94Service } from '@/core/service/l94_rfil_94.service';
import { L94Rfil94 } from '@/core/models/models/pages/l94rfil94';
import { TecnicoRilevatoreService } from '@/core/service/tecnico_rilevatore.service';
import { StrumentiService } from '@/core/service/strumenti.service';
import { TraverseService } from '@/core/service/traverse.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviatoioService } from '@/core/service/deviatoio.service';
import { Deviatoio } from '@/core/models/models/pages/deviatoio';
import { RilevamentoService } from '@/core/service/rilevamento.service';
import { RilievoDTO } from '@/core/models/models/pages/rilevamento';
import { forkJoin, Subscription, tap, debounceTime } from 'rxjs';
import { MessageService } from 'primeng/api';
import { CardModule } from 'primeng/card';
import { UtilsService } from '@/core/service/utils/utils.service';
import { SCAMBIO, UtilType } from '@/core/models/models/dominio/util.model';
import { GIUDIZIO, INDAGINE_VISIVA, PERCENTUALI, STATO, TELAI_KEYS } from '@/core/config/config-constants';
import { buildIvObject } from '@/core/config/config-helper';
import { WebcamModule } from 'ngx-webcam';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { IndagineUsuraComponent } from './card-indagine-visiva/indagine-usura-tab/indagine-usura.component';
import { IndagineCoppieComponent } from './card-indagine-visiva/indagine-coppie-tab/indagine-coppie.component';
import { IndagineTraverseComponent } from './card-indagine-visiva/indagine-traverse-tab/indagine-traverse.component';
import { IndagineAttacchiBulloneriaComponent } from './card-indagine-visiva/indagine-attacchi-bulloneria-tab/indagine-attacchi-bulloneria.component';
import { IndagineInterventiComponent } from './card-indagine-visiva/indagine-interventi-tab/indagine-interventi.component';
import { IndagineNoteComponent } from './card-indagine-visiva/indagine-note/indagine-note.component';
import { IndagineImmaginiComponent } from './card-indagine-visiva/indagine-immagini-tab/indagine-immagini.component';
import { MisureComponent } from './card-misure/misure.component';
import { addManyControls, buildTelai, mapRilievoToForm } from '@/core/config/config-helper-form';
import { BlockUIModule } from 'primeng/blockui';
import { StoricoComponent } from '../storico/storico.component';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
    selector: 'app-dettaglio-deviatoio',
    templateUrl: './dettaglio-deviatoio.component.html',
    styleUrls: ['./dettaglio-deviatoio.component.scss'],
    providers: [MessageService],
    imports: [
        CommonModule,
        TableModule,
        ButtonModule,
        ReactiveFormsModule,
        ConfirmDialogModule,
        ToastModule,
        CardModule,
        WebcamModule,
        ProgressSpinnerModule,
        DatePickerModule,
        SelectModule,
        MisureComponent,
        IndagineUsuraComponent,
        IndagineCoppieComponent,
        IndagineTraverseComponent,
        IndagineAttacchiBulloneriaComponent,
        IndagineInterventiComponent,
        IndagineNoteComponent,
        IndagineImmaginiComponent,
        StoricoComponent,
        SkeletonModule,
        BlockUIModule
    ]
})
export class DettaglioDeviatoioComponent implements OnInit, OnDestroy {
    form!: FormGroup;
    normativa: L94Rfil94[] = [];
    deviatoio!: Deviatoio;
    currentIV!: RilievoDTO;

    mode: UtilType = UtilType.NEW;

    // -- liste per select --
    tecnici: { label: string; value: number }[] = [];
    strumenti: { label: string; value: number }[] = [];
    traverse: { label: string; value: number }[] = [];

    // -- tab selezionate default --
    selectedTab: string = 'ramo1';
    selectedTabIntersezione: string = 'telaio1';

    // -- opzioni select --
    opzioniStatoUsura: any[] = [];
    opzioniCoppiaAgoContrago: any[] = [];
    legnami: any[] = [];
    bulloneria: any[] = [];

    tipoScambio!: any;

    isLoading: boolean = false;

    formReady = false;

    storicoDialogVisible = false;

    activeTab: string = 'a';

    showInfo: boolean = true;

    // -- Navigazione a sezioni (sidebar su desktop, chip su tablet): libera, non bloccante --
    readonly sections = [
        { key: 'misure', label: 'Misure', icon: 'pi pi-table' },
        { key: 'indagine', label: 'Indagine visiva', icon: 'pi pi-search' },
        { key: 'foto', label: 'Foto', icon: 'pi pi-camera' },
        { key: 'storico', label: 'Storico', icon: 'pi pi-history' }
    ] as const;
    activeSection: 'misure' | 'indagine' | 'foto' | 'storico' = 'misure';

    // Indagine visiva: accordion, una sola area aperta per volta (chiusi di default)
    openIv: string = '';
    toggleIv(key: string): void {
        this.openIv = this.openIv === key ? '' : key;
    }

    constructor(
        private fb: FormBuilder,
        private l94Service: L94Rfil94Service,
        private deviatoioService: DeviatoioService,
        private tecnicoRilevatoreService: TecnicoRilevatoreService,
        private strumentiService: StrumentiService,
        private rilevamentoService: RilevamentoService,
        private travesenteService: TraverseService,
        private route: ActivatedRoute,
        private messageService: MessageService,
        public utils: UtilsService,
        private cdr: ChangeDetectorRef,
        private router: Router,
        private location: Location
    ) {}

    private draftSub?: Subscription;

    ngOnInit(): void {
        this.loadData();
    }

    ngOnDestroy(): void {
        this.draftSub?.unsubscribe();
    }

    // ===== Bozza locale anti-perdita-dati (sopravvive al refresh) =====
    private get draftKey(): string | null {
        return this.deviatoio?.id != null ? `rilievo-draft:${this.deviatoio.id}` : null;
    }

    private attachDraftAutosave(): void {
        this.draftSub?.unsubscribe();
        if (!this.form) return;
        this.draftSub = this.form.valueChanges.pipe(debounceTime(400)).subscribe(() => this.saveDraft());
    }

    private saveDraft(): void {
        const key = this.draftKey;
        if (!key || !this.form) return;
        try {
            localStorage.setItem(key, JSON.stringify(this.form.getRawValue()));
        } catch {
            /* storage pieno/non disponibile: ignora */
        }
    }

    private restoreDraft(): void {
        const key = this.draftKey;
        if (!key || !this.form) return;
        const raw = localStorage.getItem(key);
        if (!raw) return;
        try {
            const data = JSON.parse(raw);
            if (data?.dataRilevamento) data.dataRilevamento = new Date(data.dataRilevamento);
            // l'array interventi/foto si gestisce a parte: evitiamo di romperlo col patch
            delete data.interventi;
            this.form.patchValue(data, { emitEvent: false });
        } catch {
            /* bozza corrotta: ignora */
        }
    }

    private clearDraft(): void {
        const key = this.draftKey;
        if (key) localStorage.removeItem(key);
    }

    private loadData(): void {
        this.isLoading = true;
        const id = Number(this.route.snapshot.paramMap.get('id'));
        const normativaId = Number(this.route.snapshot.queryParamMap.get('normativa'));

        this.mode = (this.route.snapshot.queryParamMap.get('mode') as UtilType) || UtilType.NEW;

        // -- opzioni select --
        this.opzioniStatoUsura = STATO.map((s) => ({ label: s, value: s }));
        this.opzioniCoppiaAgoContrago = GIUDIZIO.map((c) => ({ label: c, value: c }));
        this.legnami = PERCENTUALI.map((l) => ({ label: l, value: l }));
        this.bulloneria = PERCENTUALI.map((b) => ({ label: b, value: b }));

        // Carica sempre deviatoio e normativa
        const requests: any = {
            deviatoio: this.deviatoioService.get(id),
            normativa: this.l94Service.getL94Rfil94Byid(normativaId)
        };

        // Carica le liste solo se non sono già state caricate
        if (this.tecnici.length === 0) {
            requests.tecnici = this.tecnicoRilevatoreService.list();
        }
        if (this.strumenti.length === 0) {
            requests.strumenti = this.strumentiService.list();
        }
        if (this.traverse.length === 0) {
            requests.traverse = this.travesenteService.list();
        }

        forkJoin(requests)
            .pipe(
                tap((results: any) => {
                    this.deviatoio = results.deviatoio;
                    this.normativa = results.normativa;

                    // Popola le liste solo se sono state richieste
                    if (results.tecnici) {
                        this.tecnici = results.tecnici.map((t: any) => ({ label: t.tecnico, value: t.id }));
                    }
                    if (results.strumenti) {
                        this.strumenti = results.strumenti.map((s: any) => ({ label: s.strumento, value: s.id }));
                    }
                    if (results.traverse) {
                        this.traverse = results.traverse.map((tr: any) => ({ label: tr.traverse, value: tr.id }));
                    }

                    // Costruisce il form
                    this.buildControlsByTipo(this.deviatoio?.deviatoioTipologia?.id);
                })
            )
            .subscribe({
                next: () => (this.mode === UtilType.EDIT ? this.loadExistingRilievo(id) : this.finishLoading()),
                error: () => this.finishLoading()
            });
    }

    buildControlsByTipo(tipo: number): void {
        this.initForm();

        if (tipo === 1) {
            this.tipoScambio = SCAMBIO.SEMPLICE;
            addManyControls(this.form, this.fb, this.utils.pref('', TELAI_KEYS.SS));
            addManyControls(this.form, this.fb, INDAGINE_VISIVA.SS);
        }
        if (tipo === 2) {
            this.tipoScambio = SCAMBIO.DOPPIO;
            addManyControls(this.form, this.fb, this.utils.pref('ramo1_', TELAI_KEYS.SD_RAMO));
            addManyControls(this.form, this.fb, this.utils.pref('ramo2_', TELAI_KEYS.SD_RAMO));
            addManyControls(this.form, this.fb, this.utils.pref('cuore_', TELAI_KEYS.SD_CUORE));
            addManyControls(this.form, this.fb, INDAGINE_VISIVA.SD);
        }
        if (tipo === 3) {
            this.tipoScambio = SCAMBIO.INTERSEZIONE;
            addManyControls(this.form, this.fb, this.utils.pref('telaio1_', TELAI_KEYS.SI_T1));
            addManyControls(this.form, this.fb, this.utils.pref('telaio2_', TELAI_KEYS.SI_T2));
            addManyControls(this.form, this.fb, this.utils.pref('telaio3_', TELAI_KEYS.SI_T3));
            addManyControls(this.form, this.fb, this.utils.pref('telaio4_', TELAI_KEYS.SI_T4));
            addManyControls(this.form, this.fb, INDAGINE_VISIVA.SI);
        }
    }

    private loadExistingRilievo(id: number): void {
        this.rilevamentoService.get(id).subscribe({
            next: (res) => {
                const elem = res?.[0];
                if (!elem) return this.finishLoading();

                this.currentIV = elem;
                const patch = mapRilievoToForm(this.currentIV, this.deviatoio?.deviatoioTipologia?.id, this.tecnici, this.strumenti, this.fb);

                // Prima sostituiamo il FormArray
                this.form.setControl('interventi', patch.interventi);

                // Poi patchiamo SOLO i campi che esistono nel form
                Object.keys(this.form.controls).forEach((key) => {
                    if (key !== 'interventi' && patch.hasOwnProperty(key)) {
                        this.form.get(key)?.setValue(patch[key]);
                    }
                });

                ['dataRilevamento', 'tecnico', 'strumentoUtilizzato'].forEach((ctrl) => {
                    const control = this.form.get(ctrl);
                    if (control?.value) control.disable({ emitEvent: false });
                });

                this.formReady = true;
                this.finishLoading();
            },
            error: () => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Caricamento non riuscito',
                    detail: 'Impossibile recuperare il rilievo esistente. I dati non sono stati caricati: ricarica la pagina o riprova.'
                });
                this.finishLoading();
            }
        });
    }

    initForm(): void {
        this.form = this.fb.group({
            dataRilevamento: [this.mode === UtilType.NEW ? new Date() : null, Validators.required],
            deviatoiRiepilogoGeneraleId: [null],
            tecnico: [null, Validators.required],
            strumentoUtilizzato: [null, Validators.required],
            interventi: this.fb.array([this.newInterventoGroup()]),
            noteIndagineVisiva: [null],
            coppiaActNote: [null],
            traverseNote: [null]
        });
    }

    salva(): void {
        // Salvataggio non vincolato a un ordine di compilazione, ma i dati del
        // rilievo (data/tecnico/strumento) sono obbligatori lato backend.
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            this.messageService.add({ severity: 'warn', summary: 'Dati mancanti', detail: 'Compila Data, Tecnico e Strumento prima di salvare.' });
            return;
        }
        this.isLoading = true;
        // Lista interventi
        const listaInterventi = this.interventi.value.map((iv: any) => ({
            id: iv.id ?? null,
            noteInterventoRilevatore: iv.noteInterventoRilevatore ?? null,
            tecnicoRilevatore: { id: this.form.get('tecnico')?.value?.value ?? null },
            deviatoiRiepilogoGenerale: { id: iv.deviatoiRiepilogoGeneraleId ?? this.deviatoio.id },
            pathFile: iv.pathFile ?? null
        }));

        // Costruisco telai
        const { telaio1, telaio2, telaio3, telaio4, cuore } = buildTelai(this.form.value, this.tipoScambio);

        // Indagine visiva dinamica
        let scambioSempliceIv, scambioDoppioIv, scambioIntersDoppio;
        if (this.tipoScambio === SCAMBIO.SEMPLICE) {
            scambioSempliceIv = buildIvObject(this.form.value, this.currentIV?.scambioSempliceIv, INDAGINE_VISIVA.SS);
        } else if (this.tipoScambio === SCAMBIO.DOPPIO) {
            scambioDoppioIv = buildIvObject(this.form.value, this.currentIV?.scambioDoppioIv, INDAGINE_VISIVA.SD);
        } else if (this.tipoScambio === SCAMBIO.INTERSEZIONE) {
            scambioIntersDoppio = buildIvObject(this.form.value, this.currentIV?.scambioIntersDoppio, INDAGINE_VISIVA.SI);
        }

        // DTO finale
        const dto: RilievoDTO = {
            dataRilevamento: this.form.get('dataRilevamento')?.value,
            deviatoioId: this.deviatoio.id!,
            tecnicoRilevatoreId: this.form.get('tecnico')?.value?.value,
            strumentoRilevatoreId: this.form.get('strumentoUtilizzato')?.value?.value,
            tipoScambio: this.tipoScambio,
            indagineVisivaId:
                this.tipoScambio === SCAMBIO.SEMPLICE ? (this.currentIV?.scambioSempliceIv?.id ?? null) : this.tipoScambio === SCAMBIO.DOPPIO ? (this.currentIV?.scambioDoppioIv?.id ?? null) : (this.currentIV?.scambioIntersDoppio?.id ?? null),
            telaio1,
            telaio2,
            telaio3,
            telaio4,
            cuore,
            scambioSempliceIv,
            scambioDoppioIv,
            scambioIntersDoppio,
            listaInterventi
        };
        const isEdit = this.mode === UtilType.EDIT && !!this.currentIV?.rilevamentoScambioId;
        const req$ = isEdit ? this.rilevamentoService.update(this.deviatoio.id!, { ...dto, rilevamentoScambioId: this.currentIV!.rilevamentoScambioId! }) : this.rilevamentoService.create(dto);

        req$.pipe().subscribe({
            next: (saved: RilievoDTO) => {
                this.isLoading = false;
                this.messageService.add({
                    severity: 'success',
                    summary: 'Salvato',
                    detail: isEdit ? 'Rilevamento aggiornato correttamente.' : 'Rilevamento creato correttamente.'
                });

                // IMPORTANTISSIMO: NON ricaricare/azzerare il form dopo il salvataggio.
                // I dati inseriti restano a schermo. Aggiorniamo solo lo stato interno
                // (ids dal salvataggio) così i salvataggi successivi sono "update".
                if (saved) this.currentIV = { ...this.currentIV, ...saved };

                // Bozza non più necessaria: i dati sono persistiti. La rimuovo così
                // una futura nuova misurazione non ritrova dati vecchi.
                this.clearDraft();

                if (this.mode === UtilType.NEW) {
                    this.mode = UtilType.EDIT;
                    this.router.navigate([], {
                        relativeTo: this.route,
                        queryParams: { mode: UtilType.EDIT },
                        queryParamsHandling: 'merge',
                        replaceUrl: true
                    });
                }
            },
            error: () => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Errore',
                    detail: 'Si è verificato un problema durante il salvataggio del rilevamento.'
                });
                this.isLoading = false;
            }
        });
    }

    openStoricoDialog(): void {
        this.storicoDialogVisible = true;
    }

    goBack(): void {
        this.clearDraft();
        this.location.back();
    }

    private newInterventoGroup(): FormGroup {
        return this.fb.group({
            id: [null],
            noteInterventoRilevatore: [null],
            deviatoiRiepilogoGeneraleId: [null],
            tecnicoRilevatoreId: [null],
            foto: [null],
            pathFile: [null],
            existFile: [null]
        });
    }

    private finishLoading(): void {
        this.isLoading = false;
        this.formReady = true;
        // La bozza locale serve SOLO al recupero di una NUOVA misurazione non
        // ancora salvata (refresh/crash). In EDIT i dati arrivano dal server e
        // NON devono essere sovrascritti da una bozza rimasta in localStorage.
        if (this.mode === UtilType.NEW) {
            this.restoreDraft();
        } else {
            this.clearDraft();
        }
        this.attachDraftAutosave();
        this.cdr.detectChanges();
    }

    toggleInfo(value?: boolean) {
        this.showInfo = value ?? !this.showInfo;
    }

    get interventi(): FormArray {
        return this.form.get('interventi') as FormArray;
    }

    /** true se la sezione ha almeno un dato valorizzato (per il badge ✓ nella navigazione). */
    sectionFilled(key: string): boolean {
        if (!this.form) return false;
        if (key === 'misure') {
            const names = Object.keys(this.form.controls).filter((n) => /^(ramo1_|ramo2_|cuore_|telaio[1-4]_)?(s\d+|[a-z])$/.test(n));
            return this.anyFilled(names);
        }
        if (key === 'indagine') return this.anyFilled(this.indagineKeys);
        if (key === 'foto') return this.interventi.controls.some((c) => !!c.get('pathFile')?.value || !!c.get('existFile')?.value);
        return false;
    }

    private anyFilled(names: string[]): boolean {
        return names.some((n) => {
            const v = this.form.get(n)?.value;
            return v !== null && v !== undefined && v !== '';
        });
    }

    private get indagineKeys(): string[] {
        if (this.tipoScambio === SCAMBIO.SEMPLICE) return INDAGINE_VISIVA.SS;
        if (this.tipoScambio === SCAMBIO.DOPPIO) return INDAGINE_VISIVA.SD;
        if (this.tipoScambio === SCAMBIO.INTERSEZIONE) return INDAGINE_VISIVA.SI;
        return [];
    }
}
